import { useEffect, useState } from "react";
import { X, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { LeaderRow, tempPassword } from "@/components/deck/LeaderRow";
import { DataChangesStatus } from "@/components/deck/DataChangesStatus";

export const LeadersPanel = ({ open, onClose, me }) => {
  const [rows, setRows] = useState(null);
  const [f, setF] = useState({ name: "", email: "", password: tempPassword() });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/leaders").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { if (open) load(); }, [open]);

  const add = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/leaders", f);
      toast.success(`Added ${f.email}. Send them the temporary password: ${f.password}`, { duration: 15000, position: "bottom-right" });
      setF({ name: "", email: "", password: tempPassword() }); load();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  if (!open) return null;
  return (
    <aside className="lg lg-inbox lg-intake" data-testid="leaders-panel">
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <h3 style={{ fontSize: 18, margin: 0, marginRight: "auto" }}>Leader accounts</h3>
        <button className="lg-btn ghost sm" onClick={onClose} data-testid="leaders-close"><X size={14} /></button>
      </div>
      <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 14 }}>
        Each leader signs in with their own email. They can do everything in the deck except manage leaders. On their first sign-in they choose their own password.
      </p>
      <form onSubmit={add} className="lg-card" style={{ padding: 14, marginBottom: 16 }} data-testid="leaders-add-form">
        <div className="lg-eyebrow" style={{ marginBottom: 8 }}>Add a leader</div>
        <input className="lg-input" placeholder="Name (e.g. Toni IV)" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} style={{ marginBottom: 8 }} data-testid="leaders-add-name" />
        <input className="lg-input" type="email" required placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} style={{ marginBottom: 8 }} data-testid="leaders-add-email" />
        <label style={{ fontSize: 12, color: "var(--muted)" }}>Temporary password (send this to them)</label>
        <div style={{ display: "flex", gap: 6, margin: "4px 0 10px" }}>
          <input className="lg-input" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="leaders-add-password" />
          <button type="button" className="lg-btn ghost sm" onClick={() => setF({ ...f, password: tempPassword() })} data-testid="leaders-add-generate">New</button>
        </div>
        <button className="lg-btn sm" disabled={busy} data-testid="leaders-add-submit"><UserPlus size={13} />{busy ? "Adding…" : "Add leader"}</button>
      </form>
      {!rows && <p>Loading…</p>}
      {rows && rows.map((u) => <LeaderRow key={u.id} u={u} me={me} onChange={load} />)}
      <DataChangesStatus open={open} />
    </aside>
  );
};
